import { elFx } from '../platform/dom';
/* ============================================================
   全螢幕泛光 —— 大招發射那一拍
   ============================================================

   為什麼用 DOM 而不是後製 pass：它是一層純色疊加，用 CSS 一個 div 就做完，
   成本是零；寫成 shader pass 要多一次全螢幕繪製，而且會被泛光再糊一次
   （那會讓它變成一片糊白而不是「閃了一下」）。傷害數字也是同樣的理由用 DOM
   （見 `sim/fx.ts` 的 `initDmgPool`）。

   **上限壓在 0.30**（原本 0.55）：全白會讓玩家有 0.1 秒完全看不到自己在哪，
   而畫面正中央可能正有三十隻敵人在逼近。閃光是強調，不是遮蔽。
   使用者 2026-08-05 回報整體「太炫光」，這一項是最直接的來源之一。 */

var el: any = null, life = 0, ttl = 0.3, peak = 0;

function ensure() {
  if (el || typeof document === 'undefined' || !elFx) return el;
  el = document.createElement('div');
  el.style.cssText = 'position:absolute;inset:0;pointer-events:none;opacity:0;'
    + 'mix-blend-mode:screen;z-index:5;background:#fff';
  elFx.appendChild(el);
  return el;
}

/** 閃一下。`color` 是 CSS 顏色字串，`p` 峰值不透明度（會被壓到 0.55），
    `t` 秒數。 */
export function screenFlash(color: string, p: number, t: number) {
  if (!ensure()) return;
  el.style.background = color;
  peak = Math.min(0.30, p); ttl = t; life = t;
  el.style.opacity = String(peak);
}

/** 每幀。由 `render/weapon-fx.ts` 的 `updateWeaponFx` 一起推進 ——
    它已經是「每畫面幀一次、吃 timeScale」的那個位置，不需要第二個掛勾。 */
export function updateScreenFlash(dt: number) {
  if (!el || life <= 0) return;
  life -= dt;
  if (life <= 0) { el.style.opacity = '0'; return; }
  var k = life / ttl;
  el.style.opacity = String(peak * k * k);   // 二次方淡出：亮得快、退得乾淨
}
